import { faSpinner, faTimes, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";
import { GET_CLIENTS_END_POINT, PIPELINE_ADD_CDD_IN_THE_PIPE, PIPELINE_ROLES_BY_CLIENT } from "../../../../config/config";

interface AddCddProps {
    onClose: ()=>void;
    account_id : number | undefined;
}

interface clientsProps {
    id: number;
    client_name : string;
}

interface cddPipeLineProps {
    processed_date: string;
    cdd_name: string;
    client_id: number;
    role: string;
    cl : string;
    projected_date: string | null;
    status: number;
    status_note: string;
    cdd_num: string | null;
    add_candidates_or_switch_roles: string | null;
}

interface roleProps {
    id : number;
    position_title : string;
    career_level : string;
}

const AddCdd : React.FC<AddCddProps> = ({onClose, account_id}) => {
    const [clients, setClients] = useState<clientsProps[] | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [clientSearch, setClientSearch] = useState<string>('');
    const [roleSearch, setRoleSearch] = useState<string>('');
    const [showClientSearchCard, setShowClientSearchCard] = useState<boolean>(false);
    const [showRolesSearchCard, setShowRolesSearchCard] = useState<boolean>(false);
    const [cddPipeline, setCddPipeline] = useState<cddPipeLineProps>({
        processed_date: '',
        cdd_name: '',
        client_id: 0,
        role: '',
        cl : '',
        projected_date: null,
        status: 1,
        status_note: '',
        cdd_num: null,
        add_candidates_or_switch_roles: null
    });
    const [roles, setRoles] = useState<roleProps[] | null>(null);
    const divFloatCard = useRef<HTMLDivElement | null>(null);
    const _divFloatCard = useRef<HTMLDivElement | null>(null);
    const [fieldsValid, setFieldValid] = useState<boolean | null>(null);
    const [cddSaved, setCddSaved] = useState<boolean | null>(null);
    const [savedStatus, setSavedStatus] = useState<string>('');
    const clientTextBox = useRef<HTMLInputElement | null>(null);
    const roleTextBox = useRef<HTMLInputElement | null>(null);

    const handleClientId = (id : number) => {
        setCddPipeline({...cddPipeline, client_id: id, role: ''})
        setShowClientSearchCard(false);
    }

    // const handleRoles = (id : number) => {
    //     setCddPipeline({...cddPipeline, role : id});
    //     setShowRolesSearchCard(false);
    // }

    const handleClickOutside = (event: MouseEvent) => {
        if (
            !(_divFloatCard.current?.contains(event.target as Node)) &&
            !(divFloatCard.current?.contains(event.target as Node))
        ) {
         setShowClientSearchCard(false);
         setShowRolesSearchCard(false);
        }
    };

    const handleSubmitCddPipeline = async() => {
        let requiredFieldsHasData = true;
        if(
            cddPipeline.processed_date === '' ||
            cddPipeline.cdd_name === '' ||
            cddPipeline.client_id === 0 ||
            cddPipeline.role === '' ||
            cddPipeline.cl === '' ||
            cddPipeline.projected_date === '' ||
            !cddPipeline.projected_date
        ){
            requiredFieldsHasData = false;
        }
        if(!account_id){
            setSavedStatus('Unauthorized access, please relogin your account!');
            return false;
        }
        if(!requiredFieldsHasData){
            setFieldValid(false);
            setCddSaved(false);
            setSavedStatus('Please complete all the required fields! (Red border)');
            return false;
        }
        setLoading(true);
        console.log(cddPipeline)
        try{
            await api.post(
                PIPELINE_ADD_CDD_IN_THE_PIPE+account_id, cddPipeline, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                }
            );
            setCddSaved(true);
            setSavedStatus('Candidate added to the pipeline!');
            setLoading(false);
            onClose();
        }catch(e){
            setCddSaved(false);
            setSavedStatus('Failed to save candidate to the pipeline!');
            setLoading(false);
        }
    }

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(()=>{
        const getClients = async() => {
            try{
                const clients = await api.get(
                    GET_CLIENTS_END_POINT,{
                        headers : {'Authorization' : 'Bearer '+getToken()}
                    }
                );
                const data = clients.data as clientsProps[];
                setClients(data);
                setLoading(false);
            }catch(e){}
        }
        if(!clients) getClients();
    },[clients]);

    useEffect(()=>{
        const setRolesArr = async() => {
            try{
                const roles = await api.get(
                    PIPELINE_ROLES_BY_CLIENT+cddPipeline.client_id,{
                        headers : {'Authorization' : 'Bearer '+getToken()}
                    }
                );
                const data = roles.data as roleProps[];
                setRoles(data);
            }catch(e){}
        }
        if(cddPipeline.client_id !== 0) setRolesArr();
    },[cddPipeline.client_id])

    useEffect(()=>{
        if(showClientSearchCard) clientTextBox.current?.focus();
        if(showRolesSearchCard) roleTextBox.current?.focus();
    },[showClientSearchCard, showRolesSearchCard]);

    return(
        <div className="min-w-[28rem] max-w-[48rem] relative">
            <div className={loading ? 'modal-loader' : 'hidden'}>
                <FontAwesomeIcon className="animate-spin" icon={faSpinner} />
            </div>
            <div className="text-center uppercase font-medium text-gray-600 text-xl">
                ADD CANDIDATE
            </div>
            <form>
                <div className={cddSaved ? 'text-green-600' : 'text-red-500'}>
                    {savedStatus}
                </div>
                <div className="flex gap-4">
                    <div className="w-1/2">
                        <div className='input-container'>
                            <label>Processed Date: </label>
                            <input 
                                type="date" 
                                onChange={(e)=>setCddPipeline({...cddPipeline, processed_date : e.currentTarget.value})} 
                                value={cddPipeline.processed_date} 
                                className={`text-box cursor-pointer ${fieldsValid === false && !cddPipeline.processed_date ? 'border-2 border-red-400' : ''}`}
                            />
                        </div>
                        <div className='input-container'>
                            <label>Candidate Name: </label>
                            <input 
                                type="text" 
                                onChange={(e)=>setCddPipeline({...cddPipeline, cdd_name : e.currentTarget.value})} 
                                value={cddPipeline.cdd_name} 
                                className={`text-box ${fieldsValid === false && cddPipeline.cdd_name === '' ? 'border-2 border-red-400' : ''}`} 
                            />
                        </div>
                        <div className='input-container relative'>
                            <label>Client:</label>
                            <input 
                                type="text"
                                readOnly 
                                onClick={()=>setShowClientSearchCard(showClientSearchCard ? false : true)} 
                                value={clients?.find(client => client.id === cddPipeline.client_id)?.client_name || ''} 
                                className={`text-box ${fieldsValid === false && cddPipeline.client_id === 0 ? 'border-2 border-red-400' : ''}`} 
                            />
                            <div ref={divFloatCard} className={!showClientSearchCard ? "hidden" : "absolute bg-white p-2 shadow-xl border-2 w-full mt-0.5 h-52 max-h-52 z-50"}>
                                <div className="flex flex-col">
                                    <label className="text-sm">Search client:</label>
                                    <input type="text" ref={clientTextBox} onChange={(e)=>setClientSearch(e.currentTarget.value)} value={clientSearch} className="outline-none px-2 border border-gray-400" />
                                </div>
                                <div className="mb-2">
                                    <small>Clients:</small>
                                </div>
                                <div className="flex flex-col max-h-28 overflow-y-auto">
                                    {clientSearch !== '' ? clients
                                        ?.filter(client => client.client_name.toLowerCase().includes(clientSearch.toLowerCase()))
                                        .map(client => (
                                            <div key={client.id} onClick={()=>handleClientId(client.id)} className="hover:bg-gray-200 py-1 px-1 cursor-pointer">
                                                {client.client_name}
                                            </div>
                                    )) : (<div>No client found.</div>)}
                                </div>
                            </div>
                        </div>
                        <div className='input-container relative'>
                            <label>Role/Position title: <i className="text-sm text-red-400">{cddPipeline.client_id === 0 ? 'Select client first' : ''}</i></label>
                            <input 
                                type="text" 
                                onClick={()=>setShowRolesSearchCard(cddPipeline.client_id === 0 ? false : showRolesSearchCard ? false : true)} 
                                value={cddPipeline.role}
                                readOnly 
                                className={`text-box ${fieldsValid === false && cddPipeline.role === '' ? 'border-2 border-red-400' : ''}`} 
                            />
                            <div ref={_divFloatCard} className={!showRolesSearchCard ? "hidden" : "absolute bg-white p-2 shadow-xl border-2 w-full mt-0.5 h-52 max-h-52 z-50"}>
                                <div className="flex flex-col">
                                    <label className="text-sm">Type role:</label>
                                    <input type="text" ref={roleTextBox} onChange={(e)=>setCddPipeline({...cddPipeline, role : e.currentTarget.value})} className="outline-none px-2 border border-gray-400" />
                                </div>
                                <div className="mb-2">
                                    <small>Roles:</small>
                                </div>
                                <div className="flex flex-col max-h-28 overflow-y-auto">
                                    {/* {roleSearch !== '' ? roles
                                        ?.filter(role => role.position_title.toLowerCase().includes(roleSearch.toLowerCase()))
                                        .map(role => (
                                            <div key={role.id} onClick={()=>handleRoles(role.id)} className="hover:bg-gray-200 py-1 px-1 cursor-pointer">
                                                {role.position_title}
                                            </div>
                                    )) : (<div>No role found.</div>)} */}
                                </div>
                            </div>
                        </div>
                        <div className='input-container flex gap-2'>
                            <div>
                                <label>Career Level:</label>
                                <input 
                                    type="text" 
                                    value={cddPipeline.cl}
                                    onChange={(e)=>setCddPipeline({...cddPipeline, cl : e.currentTarget.value})}
                                    className={`text-box ${fieldsValid === false && cddPipeline.cl === '' ? 'border-2 border-red-400' : ''}`}
                                />
                            </div>
                            <div>
                                <label>Projected Start Date:</label>
                                <input 
                                    type="date" 
                                    onChange={(e)=>setCddPipeline({...cddPipeline, projected_date : e.currentTarget.value})} 
                                    value={cddPipeline.projected_date ? cddPipeline.projected_date : ''} 
                                    className={`text-box ${fieldsValid === false && (cddPipeline.projected_date === '' || !cddPipeline.projected_date) ? 'border-2 border-red-400' : ''}`} />
                            </div>
                        </div>
                        <div className='input-container'>
                            <label>Status:</label>
                            <select onChange={(e)=>setCddPipeline({...cddPipeline, status : parseInt(e.currentTarget.value)})} className="text-box">
                                <option value="1" selected={cddPipeline.status === 1}>On Initial Stage</option>
                                <option value="2" selected={cddPipeline.status === 2}>On Mid Stage</option>
                                <option value="3" selected={cddPipeline.status === 3}>On Final Stage</option>
                                <option value="4" selected={cddPipeline.status === 4}>For Job Offer</option>
                                <option value="5" selected={cddPipeline.status === 5}>Offer Accepted</option>
                                <option value="6" selected={cddPipeline.status === 6}>Onboarded</option>
                                <option value="7" selected={cddPipeline.status === 7}>Withdraw</option>
                                <option value="8" selected={cddPipeline.status === 8}>Reneged</option>
                                <option value="9" selected={cddPipeline.status === 9}>Source Tagging</option>
                                <option value="10" selected={cddPipeline.status === 10}>Closed Role</option>
                                <option value="11" selected={cddPipeline.status === 11}>Offer Rejected</option>
                                <option value="0" selected={cddPipeline.status === 0}>Failed</option>
                            </select>
                        </div>
                    </div>
                    <div className="w-1/2">
                        <div className='input-container'>
                            <label>Status Note (Optional):</label>
                            <textarea onChange={(e)=>setCddPipeline({...cddPipeline, status_note : e.currentTarget.value})} value={cddPipeline.status_note ? cddPipeline.status_note : ''} className='text-box min-h-24' />
                        </div>
                        <div className='input-container'>
                            <label>HOW MANY CANDIDATES DO YOU HAVE IN THE PIPELINE FOR THIS ROLE? (Optional)</label>
                            <input 
                                type="text" 
                                onChange={(e)=>setCddPipeline({...cddPipeline, cdd_num : e.currentTarget.value})} 
                                value={cddPipeline.cdd_num ? cddPipeline.cdd_num : ''} 
                                className='text-box'
                            />
                        </div>
                        <div className='input-container'>
                            <label>WILL YOU BE ADDING MORE CANDIDATES OR MOVING ON TO OTHER ROLES? (Optional)</label>
                            <textarea onChange={(e)=>setCddPipeline({...cddPipeline, add_candidates_or_switch_roles : e.currentTarget.value})} value={cddPipeline.add_candidates_or_switch_roles ? cddPipeline.add_candidates_or_switch_roles : ''} className='text-box h-36' />
                        </div>
                    </div>
                </div>

                <div className='input-container flex'>
                    <div className="ms-auto flex gap-2 items-center">
                        <div>
                            <button type="button" onClick={handleSubmitCddPipeline} className='button button-vcc-primary'>
                                <FontAwesomeIcon icon={faUserPlus} />&nbsp;
                                Add CDD
                            </button>
                        </div>
                        <div>
                            <button type="button" onClick={onClose} className='button button-red'>
                                <FontAwesomeIcon icon={faTimes} />&nbsp;
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default AddCdd;